const notificationMessages = {
  CAMPAIGN_REMOVED_SUCCESS: { message: 'Campanha excluída com sucesso', kind: 'success' },
  EMAIL_FLOW_CUSTOM_REMOVED_SUCCESS: { message: 'Fluxo de email excluído com sucesso', kind: 'success' },
  SCHEDULE_EMAIL_SUCCESS: { message: 'Sua campanha foi agendada com sucesso', kind: 'success' },
  SEND_EMAIL_NOW_SUCCESS: { message: 'Sua campanha foi enviada com sucesso', kind: 'success' },
};

export default notificationMessages;
